import { useMutation } from "@tanstack/react-query"
import { insertNdaInfo } from "@/api"

export const useInsertNda = () => {
  return useMutation({
    mutationFn: ({
      legalName,
      email,
      address,
      city,
      state,
      zip,
      country,
      phone,
      dealManagerName,
      dealManagerEmail
    }: {
      legalName: string
      email: string
      address: string
      city: string
      state: string
      zip: string
      country?: string
      phone: string
      dealManagerName: string
      dealManagerEmail: string
    }) =>
      insertNdaInfo({
        legalName,
        email,
        address,
        city,
        state,
        zip,
        country,
        phone,
        dealManagerName,
        dealManagerEmail
      }),
  })
}